import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
  Input
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector:  '[ngModel][lm-displayupper]',  // tslint:disable-line
  providers: [ NgModel ]
})
export class LMFieldUpperCaseDirective {

  @HostBinding('class.lm-uppercase') get isUpper() {
    return this.isUpperCase;
  };

  @Input() public set isUpperCase(value: boolean | string) {
    if (typeof value === 'string') {
      this._isUpperCase = (value === 'true');

    } else {
      this._isUpperCase = value;
    }
  };

  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  private _isUpperCase = false;

  constructor(private model: NgModel) {
  }

  public get isUpperCase() {
    return this._isUpperCase;
  }

  // updates the model with the transformed value
  // change event occurs before a blur event
  // input event occurs between keypress and keyup events
  @HostListener('change', [ '$event' ])
  onInputChange(event) {
    if (event && event.target && event.target.value && this.isUpperCase) {
      const value = event.target.value.toUpperCase();
      this.ngModelChange.emit(value);
    }
  };
}
